import { IconChevronLeft, IconPrinter } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

export default function ViewVehicleDetails() {
  const Section = ({
    title,
    children,
  }: {
    title: string;
    children: React.ReactNode;
  }) => (
    <div className="p-4 sm:p-6 bg-[#F7F6F2] rounded-xl border border-[#EFEFEF] shadow-sm space-y-4">
      <h2 className="text-[#212121]/70 font-medium text-base sm:text-lg">
        {title}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-4">
        {children}
      </div>
    </div>
  );

  const TwoCol = ({
    label,
    value,
  }: {
    label: string;
    value: React.ReactNode;
  }) => (
    <p className="text-sm text-[#1E293B] flex items-center gap-1">
      <span className="font-medium text-[#212121]">{label}:</span> {value}
    </p>
  );

  const navigate = useNavigate();

  return (
    <div className="p-4 space-y-4">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-3">
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            className="flex justify-center items-center rounded-full h-10 w-10 sm:h-12 sm:w-12 bg-white border border-[#D8D8D8]"
          >
            <IconChevronLeft size={20} />
          </button>
          <h1 className="text-xl sm:text-2xl md:text-3xl  text-[#212121]">
            Request ID: 56465465
          </h1>
        </div>
        <button className="bg-[#FBD037] hover:bg-yellow-400 text-black flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium w-fit">
          <IconPrinter size={18} />
          <span className="whitespace-nowrap">Print</span>
        </button>
      </div>

      {/* Sections */}
      <Section title="Request Info">
        <TwoCol label="Origin" value="Riyadh" />
        <TwoCol label="Destination" value="Riyadh" />
        <TwoCol label="Staff" value="Admin" />
        <TwoCol label="Weight / Capicity" value="1 Tone" />
        <TwoCol label="Request Date" value="4 Aug 2025" />

        <div className="col-span-full space-y-3">
          <h3 className="text-[#212121]/70 font-medium text-base">
            Company Info
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-4">
            <TwoCol label="Company Name" value="Company Name" />
            <TwoCol label="Mobile Number" value="1234567897" />
            <TwoCol label="Contact Person" value="Alok Kumar" />
            <TwoCol label="Email" value="examplemail@gmail.com" />
          </div>
        </div>

        <div className="col-span-full space-y-3">
          <h3 className="text-[#212121]/70 font-medium text-base">
            Driver Info
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-4">
            <TwoCol label="Driver Name" value="Aquib Khan" />
            <TwoCol label="Mobile Number" value="6345856565" />
            <TwoCol
              label="Iqma Number"
              value={
                <div className="flex items-center gap-1">
                  985200212 <img src="/img/download-icon.svg" alt="download" />
                </div>
              }
            />
            <TwoCol
              label="License"
              value={
                <div className="flex items-center gap-1">
                  985200212 <img src="/img/download-icon.svg" alt="download" />
                </div>
              }
            />
          </div>
        </div>

        <div className="col-span-full space-y-3">
          <h3 className="text-[#212121]/70 font-medium text-base">
            Vehicle Info
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-4">
            <TwoCol label="Vehicle Number" value="RJ-14-64654" />
            <TwoCol label="Vehicle Type" value="Van" />
            <TwoCol
              label="RC Number"
              value={
                <div className="flex items-center gap-1">
                  65465465564{" "}
                  <img src="/img/download-icon.svg" alt="download" />
                </div>
              }
            />
            <TwoCol
              label="Vehicle Doc"
              value={<img src="/img/download-icon.svg" alt="download" />}
            />
          </div>
        </div>
      </Section>
    </div>
  );
}
